import { useRef, useState } from 'react';
import type { FormEvent } from 'react';
import { errorMessage } from '../api/hotel';

export function useAction() {
    const [pending, setPending] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const busy = useRef(false);
    async function run(action: () => Promise<void>) {
        if (busy.current) return;
        busy.current = true; setPending(true); setError(null);
        try { await action(); } catch (error) { setError(errorMessage(error)); }
        finally { busy.current = false; setPending(false); }
    }
    function submit(action: () => Promise<void>) { return (event: FormEvent) => { event.preventDefault(); void run(action); }; }
    return { pending, error, setError, run, submit };
}
